import { assert_string_object_id, assert_true } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__generation_setting_change } from '../settings/ENUM__generation_setting_change';

export class DTO_REQUEST__generation_update extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION_UPDATE;

  /*
   * FIELDS
   */

  generation_id: string;
  //key - EGenerationSettingType or EGenerationSettingChangeType, value - update data
  update_map: MAP__serializable<string, unknown>;

  /*
   * METHODS
   */

  constructor(generation_id: string = '') {
    super();

    this.generation_id = generation_id;
    this.update_map = new MAP__serializable();
  }

  try_set_bundle_from_ml_assets(settings: 'DTO__generation_settings_sd_1', ml_assets_map: Map<string, DTO__ml_asset>) {
    let bundles = ml_assets_map.values().filter(item => item.type == ENUM__ml_asset_type.BUNDLE);

    //set empty bundle as fallback
    this.update_map.set(ENUM__generation_setting_change.ML_ASSET_BUNDLE_USE, ENUM__string_id_empty.HASH_SHA256);

    for (let bundle of bundles) {
      this.update_map.set(ENUM__generation_setting_change.ML_ASSET_BUNDLE_USE, bundle.hash_sha256);

      break;
    }
  }

  contains_any_updates(): boolean {
    let update_map = this.update_map.to_object();

    return Object.keys(update_map).length > 0;
  }

  private contains_only_one_update(): boolean {
    let update_map = this.update_map.to_object();

    return Object.keys(update_map).length == 1;
  }

  contains_update(type: string): boolean {
    let update_map = this.update_map.to_object();

    return Object.keys(update_map).includes(type);
  }

  contains_image_size_update() {
    return (
      this.contains_update(ENUM__generation_setting_change.IMAGE_SIZE_USE_ASPECT_RATIO) ||
      this.contains_update(ENUM__generation_setting_change.IMAGE_SIZE_USE_MULTIPLIER)
    );
  }

  /*
   * ASSERTS
   */
  assert_standard_fields(): void {
    assert_string_object_id(this.generation_id);
  }

  assert_contains_one_update<TValue>(key: string): TValue {
    assert_true(this.contains_only_one_update(), { context: 'update_map' });

    return this.update_map.get_or_assert_typed<TValue>(key);
  }

  assert_contains_any_updates(): void {
    assert_true(this.contains_any_updates(), { context: 'update_map' });
  }
}
